// extracted by mini-css-extract-plugin
export var container = "price-module--container--c329d";
export var originalPrice = "price-module--original-price--da674";
export var priceLoader = "price-module--price-loader--9e485";